<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'AboutHistoryHeader',
  inject: ['wp']
}
</script>
